function isNullish(value) {
    return value === null || value === undefined || value === '';
}

class GiftDispatcher extends HTMLElement {
    constructor() {
        super();
        this.gifts = this.querySelectorAll('input[type="hidden"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
 
        this.cartURLs = {
            add: `${window.themeVariables.routes.cartAddUrl}.js`,
            change: `${window.themeVariables.routes.cartChangeUrl}.js`,
            update: `${window.themeVariables.routes.cartUpdateUrl}.js`,
            cart: `${window.themeVariables.routes.cartUrl}.js`,
        };
    }

    connectedCallback() {
        if (this.dataset.enable) {
            this.listenEvents();
        }
    }

    disconnectedCallback() {
        this.removeEvents();
    }

    listenEvents() {
        // Écoute des événements de mise à jour du panier provenant d'autres sources
        document.addEventListener('cart:updated', (event) => {
            if (!event.detail?.fromGiftDispatcher) {
                this.getCart().then(cart => { this.validateConditions(cart)});
            }
        });
    }

    removeEvents() {
        document.removeEventListener('cart:updated', this.handleCartUpdate);
    }

    async getCart() {
        return fetch(this.cartURLs.cart, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(response => {
            return response;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    validateConditions(cart) {
        for (const gift of this.gifts) {
            if(isNullish(gift.dataset.variantId) || isNullish(gift.dataset.tierType)) return;

            const variantId = parseInt(gift.dataset.variantId);
            const tierType = gift.dataset.tierType;
            const isSufficient = this.isTierSatisfied(cart, tierType, gift);

            if(isSufficient === false) {
                continue;
            }
            
            if(this.isAlreadyOnCart(cart, variantId)) {
                continue;
            }

            this.addToCartGift(variantId);
        }
    }

    isTierSatisfied(cart, type, gift) {
        switch (type) {
            case 'cart_items_count':
                return GiftDispatcherOnCartItemsCount.validateConditions(cart, gift);
            case 'cart_amount':
                return GiftDispatcherOnCartAmount.validateConditions(cart, gift);
            case 'product_on_cart':
                return GiftDispatcherOnProductInCart.validateConditions(cart, gift);
            default:
                return false;
        }
    }

    isAlreadyOnCart(cart, variantId) {
        return cart.items.some((item) => item.variant_id == variantId);
    }

    async updateCart(response) {
        // Récupération du contenu du panier
        const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
        const cartContent = await cartResponse.json();
        
        // Dispatch des événements avec le panier mis à jour
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
                cart: cartContent,
                fromGiftDispatcher: true
            }
        }));

        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
                cart: cartContent,
                openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
            }
        }));
    }

    async addToCartGift(variantId) {
        let bodyConfig = JSON.stringify({
            items: [
                {
                    id: variantId,
                    quantity: 1,
                },
            ],
        });

        return fetch(this.cartURLs.add, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodyConfig, 
        })
        .then((response) => response.json())
        .then((response) => {
            this.updateCart(response);
        }).catch((error) => {
            console.error('Error adding gift to cart:', error);
        });
    }
}

customElements.define('gift-dispatcher', GiftDispatcher);

var GiftDispatcherOnCartAmount = class {
    static isCartAmountSufficient(cart, cartAmount) {
        const cartTotal = cart.items_subtotal_price;
        return cartTotal >= cartAmount;
    }

    static validateConditions(cart, gift) {
        if (isNullish(gift.dataset.cartAmount)) return false;

        const cartAmount = parseFloat(gift.dataset.cartAmount);
        const isSufficient = this.isCartAmountSufficient(cart, cartAmount);
        const isAvailable = gift.dataset.variantAvailable === "true";

        if (!isSufficient) {
            return false;
        }

        if (!isAvailable) {
            return false;
        }

        return true;
    }
}

var GiftDispatcherOnCartItemsCount = class {
    static isCartItemsCountSufficient(cart, cartItemsCount) {
        const cartItems = cart.item_count;
        return cartItems >= cartItemsCount;
    }

    static validateConditions(cart, gift) {
        if (isNullish(gift.dataset.cartItemsCount)) return false;

        const cartItemsCount = parseInt(gift.dataset.cartItemsCount);
        const isSufficient = this.isCartItemsCountSufficient(cart, cartItemsCount);
        const isAvailable = gift.dataset.variantAvailable === "true";

        if (!isSufficient) {
            return false;
        }

        if (!isAvailable) {
            return false;
        }

        return true;
    }
}

var GiftDispatcherOnProductInCart = class {
    static isProductDispatcherOnCart(cart, productId) {
        return cart.items.some((item) => item.product_id == productId);
    }

    static validateConditions(cart, gift) {
        if (isNullish(gift.dataset.variantId)) {
            return false;
        }

        const isAvailable = gift.dataset.variantAvailable === "true";
        const productDispatcherId = parseInt(gift.dataset.productDispatcherId);
        const isProductDispatcherOnCart = this.isProductDispatcherOnCart(cart, productDispatcherId);

        if(!isProductDispatcherOnCart) {
            return false;
        }

        if (!isAvailable) {
            return false;
        }

        return true;
    }
}

 